import { useEffect, useState } from 'react';
import { Logger } from '../utils';
import { useTwilioAppState } from '../state/';

const usePublications = participant => {
    const [publications, setPublications] = useState([]);
    const { _isMounted } = useTwilioAppState();
    useEffect(() => {
        if (_isMounted && _isMounted.current === true) {
            // Reset the publications when the 'participant' variable changes.
            setPublications(participant && participant.tracks.values() ? Array.from(participant.tracks.values()) : []);

            const publicationAdded = publication => {
                Logger("UI.Twilio.Publication.Added", new Date());
                setPublications(prevPublications => [...prevPublications, publication]);
            }
            const publicationRemoved = publication => {
                Logger("UI.Twilio.Publication.Removed", new Date());
                setPublications(prevPublications => prevPublications.filter(p => p !== publication));
            }
            if (participant) {
                participant.on('trackPublished', publicationAdded);
                participant.on('trackUnpublished', publicationRemoved);
            }
            return () => {
                if (participant) {
                    participant.off('trackPublished', publicationAdded);
                    participant.off('trackUnpublished', publicationRemoved);
                }
            };
        }
    }, [participant, _isMounted]);

    return publications;
};

export default usePublications;
